import React, {Component} from 'react';
import {Table, Button, Icon, Alert} from 'antd';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

// ***
// import reqwest from 'reqwest';
// import axios from 'axios';

// import components
import ResultListActionButtons from '../components/FileListTable.ActionButtons';
import ResultListViewButtons from '../components/FileListTable.ViewButtons';
// import data
import {columnDataObj, output_files, file_descs} from '../assets/constants/sessionFileList';

// ***
// import test data to generate Table for output file list
import {fileListData} from '../../test/test-data/fileListTable';

function updateColumnDataObj(index, file, id, url){
  //create a deep clone of the origial data object
  let _ele = JSON.parse(JSON.stringify(columnDataObj));
  //update values for the corresponding keys in cloned data object
  _ele.key = index;
  _ele.file = file;

  _ele.action.id = id;
  _ele.action.url = url;
  _ele.action.link = file;

  _ele.view.id = id;
  _ele.view.url = url;
  _ele.view.link = file;
  //return the updated data object
  //console.log(_ele);
  return _ele;
}

function generate_file_array(file_array, id, url){
  let _array = [];

  for(let i = 0; i < file_array.length; i ++){
    let obj = {};

    // special files, stored in output_files array, can be specifically marked
    // will come back to part later
    if(output_files.includes(file_array[i])){
      let file = file_array[i];
      //Deep clone of the updated data object
      obj = JSON.parse(JSON.stringify(updateColumnDataObj(i, file, id, url)));
      let index = output_files.indexOf(file_array[i]);

      if(file_descs[index]){
        obj.description = file_descs[index].desc;
        obj.view.types = file_descs[index].view;
      }else{
        obj.description = "N/A";
        obj.view.types = [];
      }
    }else{
      let file = file_array[i];
      //Deep clone of the updated data object
      obj = JSON.parse(JSON.stringify(updateColumnDataObj(i, file, id, url)));
      let index = output_files.indexOf(file_array[i]);

      if(file_descs[index]){
        obj.description = file_descs[index].desc;
        obj.view.types = file_descs[index].view;
      }else{
        obj.description = "N/A";
        obj.view.types = [];
      }
    }
    _array.push(obj);
  }
  //console.log(_array);
  return _array;
}

const columns = [
  {
    title: 'File',
    dataIndex: 'file',
    key: 'file',
    className: 'col-file',
    render: (text)=>(<p><Icon type="file-text" style={{marginRight:10}}/>{text}</p>)
  }, 
  {
    title: 'View', 
    dataIndex: 'view', 
    key: 'view',
    className: 'col-view',
    render: (text)=>(<ResultListViewButtons text={text}></ResultListViewButtons>)   
  },
  {
    title: 'Action', 
    dataIndex: 'action', 
    key: 'action',
    className: 'col-action',
    render: (text)=>(<ResultListActionButtons text={text}></ResultListActionButtons>)   
  }
];


class ResultList extends Component{

  constructor(props){
    super(props);
    this.state={
      selectedRows: []
    }
  }

  componentDidUpdate(prevProp){
    // console.log('component did update');
    // console.log(prevProp);
    // console.log(this.props);

    // ***
    // this doesn't update the UI
    // so you will still see files being selected
    // but 'download' button is not activated as intented
    // 
    if(prevProp.id !== this.props.id){
      this.setState({selectedRows: []});
    }
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    // console.log('selectedRows changed: ', selectedRows);
    let _selectedRows = selectedRows.map((file, index)=>{
      return file.file;
    })
    // console.log(_selectedRows);
    this.setState({ selectedRows: _selectedRows });
  };
  
  // might be useful someday :)
  handleChange = (pagination) => {
    //this is not yet needed
    //console.log('Various parameters', pagination);
  }

  downloadAll = (url, id) => {
    // old version
    // let link = 'http://localhost/download_as_zip.php?id='+id;
    // document.location = link;

    // ***
    // version 2.0.0
    // console.log(`${url}${id}`);
    // ONLY works when file size is not too large...less than 100MB I guess
    document.location = `${url}${id}`;

    // trying fetch, not working...
    // const response = await fetch(`${url}${id}`, {
    //   method: 'GET',
    // });
    // const doc = await response.blob();
    // var link = document.createElement('a');
    // link.href = window.URL.createObjectURL(doc);
    // link.download = "Meta_result.zip";
    // link.click();
  }

  downloadSelectedFiles = (url, id) => {
    // console.log('download selected files');
    
    let _selectionString = JSON.stringify(this.state.selectedRows);
    let queryString = `${url}?id=${id}&selection=${_selectionString}`;
    // console.log(queryString);
    document.location = queryString;

    
    // document.location = `${url}?id=${id}&selection[]=${this.state.selectedRows}`;
    // reqwest({
    //   url: url,
    //   method: 'post',
    //   data: {selection: this.state.selectedRows, sess_id: id},
    //   crossOrigin: true,
      
    // }).then(res=>{
    //   console.log(res);
      
    //   // document.location = `${url}${id}`;
    //   var blob = new Blob([res.response],{type: 'application/zip'});
    //   var link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = "Meta_result.zip";
    //   link.click();
    // });
  }

  // download each individual folder
  // report
  // OR taxonomy analysis
  // OR function annotation
  downloadReport = (url, id) => {
    // console.log(`${url}?id=${id}`);
    document.location = `${url}?id=${id}`;
  }

  // ***
  // not working right now...
  viewReport = async (url, id) => {
    // console.log("view report");
    // console.log(`${url}?id=${id}`);
    // document.location = `${url}?id=${id}`;

    // const response = await fetch(`${url}?id=${id}`, {
    //   method: 'GET',
    // });
    // console.log(response);
    // const doc = await response.blob();
    // var link = document.createElement('a');
    // link.href = window.URL.createObjectURL(doc);
    // link.click();
  }

  render(){
    // console.log(this.props);
    // console.log(this.state);

    const {
      download_file, 
      download_all, 
      download_selection, 
      download_report, 
      download_result, 
      download_function, 
      download_taxonomy, 
      view_report, 
      id, 
      resultFiles, 
      reportReady} = this.props;
    const {selectedRows} = this.state;

    //create a clone of the original file array
    const fileArr = resultFiles.slice();
    const data = generate_file_array(fileArr, id, download_file);

    const rowSelection = {
      selectedRows,
      onChange: this.onSelectChange,
    };

    const hasSelected = selectedRows.length > 0;

    return(
      <div>
        <div css={css`
          width: 80%;
          margin: 20px auto;
        `}>
          <div css={css`
            background: #B3E5FC; 
            padding: 10px; 
            text-align: center;
            margin: 25px;
            border-radius: 10px;
          `}>
            <h3>iMetaLab Data Processing Session Results</h3>
            <h5>{`Session ID: ${id}`}</h5>
          </div>
        </div>
        <div className="table-operations">
          {
            reportReady
            ? <div css={css`
              padding: 10px;
            `}>
              <Alert
                message="Download Session Results by Selection"
                description="Your session results are now ready for download.  The results contains a collection of database search results, taxonomy analysis, functional annotation and data visualization modules based on your data processing results."
                type="success"
                showIcon
              />
            </div>
            : <div css={css`
              padding: 10px;
            `}>
              <Alert
                message="Download Session Results by Selection"
                description="Session results will become available for download at the end of each Data processing. The results contains a collection of database search results, taxonomy analysis, functional annotation and data visualization modules based on your data processing results."
                showIcon="info"
              />
            </div>
          }

          <div css={css`
            padding: 10px;
          `}>
            <Alert
              message="If download fails, try to select less number of files for each download."
              type="warning"
              showIcon
            />
          </div>

          {
            hasSelected
            ? <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadSelectedFiles(download_selection, id)}>Download Selected Session Results</Button>
            : <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download Selected Session Results</Button>
          }
          <span>{`Selected ${selectedRows.length} Files`}</span> 
          
        </div>
        <Table 
          rowSelection={rowSelection}
          dataSource={data} 
          columns={columns} 
          onChange={this.handleChange}
          expandedRowRender={record => <p><Icon style={{marginRight:10}} type="info-circle-o"/>{record.description}</p>} />

          {
            reportReady
            ? <div css={css`
              padding: 10px;
            `}>
              <Alert
                message="Download Session Results by Category"
                description="Your session results are now ready for download.  The results contains a collection of database search results, taxonomy analysis, functional annotation and data visualization modules based on your data processing results."
                type="success"
                showIcon
              />
            </div>
            : <div css={css`
              padding: 10px;
            `}>
              <Alert
                message="Download Session Results by Category"
                description="Session results will become available for download at the end of each Data processing. The results contains a collection of database search results, taxonomy analysis, functional annotation and data visualization modules based on your data processing results."
                showIcon="info"
              />
            </div>
          }
          
          {
            !reportReady
            ? <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download Session Report</Button>
            : <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadReport(download_report, id)}>Download Session Report</Button>
          }

          {
            !reportReady
            ? <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download Data Processing Result</Button>
            : <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadReport(download_result, id)}>Download Data Processing Result</Button>
          }

          {
            !reportReady
            ? <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download Taxonomy Analysis</Button>
            : <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadReport(download_taxonomy, id)}>Download Taxonomy Analysis</Button>
          }

          {
            !reportReady
            ? <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download Function Annotation</Button>
            : <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadReport(download_function, id)}>Download Function Annotation</Button>
          }

          <div css={css`
            padding: 10px;
          `}>
            <Alert
              message="Download all results"
              description="Allows you to download all the results in a zip folder. However, if the total size exceeds 100MB, the download process could fail and we recommend to download the results in smaller packages using <Download selected files> option."
              type="info"
              showIcon
            />
          </div>
          {
            resultFiles.length === 0
            ? <Button type="primary"
            icon="download" 
            disabled
            style={{margin: 12,}}>Download All</Button>
            : <Button type="primary"
            icon="download" 
            style={{margin: 12,}}
            onClick={()=>this.downloadAll(download_all, id)}>Download All</Button>
          }
      </div>
    );
  }
}

export default ResultList;

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

// NOT working, temp removed
// {
//   !reportReady
//   ? <Button type="primary"
//   icon="eye-o" 
//   disabled
//   style={{margin: 12,}}>View Report</Button>
//   : <Button type="primary"
//   icon="eye-o" 
//   style={{margin: 12,}}
//   disabled
//   onClick={()=>this.viewReport(view_report, id)}>View Report</Button>
// }
